var React = require('react');
var moment = require('moment');

var DateFormatter = React.createClass({

	render: function() {
		var me = this, createdAt = me.props.data;

		return (
			<span>
				{moment(createdAt).format('L')}
			</span>
		)
	}

});

module.exports = DateFormatter;


// WEBPACK FOOTER //
// ./src/components/Formatters/DateFormatter.jsx